// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__341i8","filesListContainer":"PosDisputesFiles_filesListContainer__3Zwe-","filesButton":"PosDisputesFiles_filesButton__2oKwK"};